import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '@modules/auth/services/auth.service';
import { Observable } from 'rxjs';
import { take, tap } from 'rxjs/operators';

export const authGuard: CanActivateFn = (route, state): Observable<boolean> => {
  const authService = inject(AuthService);

  return authService.estaAutenticado$.pipe(
    take(1),
    tap((estaAutenticado) => {
      if (!estaAutenticado) {
        console.warn(`[AuthGuard] Usuário não autenticado. Redirecionando para /login`);
        authService.deslogar();
      }
    }),
  );
};
